import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {packsService} from "../../../services/settings-services";


const initialState = {
    packs: [],
    status: null,
    error: null,
    trigger: 0,
}

const getAllPacks = createAsyncThunk(
    'packsSlice/getAllPacks',
    async (_, {rejectWithValue}) => {
        try {
            return await packsService.getAllPack();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const packsSlice = createSlice({
    name: "packsSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllPacks.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllPacks.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.packs = action.payload;
            })
            .addCase(getAllPacks.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: packsReducer, actions} = packsSlice;
const packsActions = {
    ...actions,
    getAllPacks
}

export {
    packsReducer,
    packsActions
}